import { AGE_VERIFICATION_STATUS } from 'js/hooks/user/constants';

export const NEED_VERIFICATION_STATUSES = [
    AGE_VERIFICATION_STATUS.FAILED,
    AGE_VERIFICATION_STATUS.REVIEW,
    AGE_VERIFICATION_STATUS.UNKNOWN
];

export const NO_NEED_VERIFICATION_STATUSES = [
    AGE_VERIFICATION_STATUS.PASSED,
    AGE_VERIFICATION_STATUS.ACTIVE_GRACE_PERIOD
];
